import React from 'react';
import PropTypes from 'prop-types';

// IDPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const ContactDetailsSingapore = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { phoneNo, emailAddress, errors } = formState;

  const inputElements = [
    {
      belongsTo: [
        'Singapore Credit Bureau',
        'Singapore Residential',
        'Singapore Utility',
      ],
      element: (
        <TextFieldGroup
          key="phoneNo"
          id="phoneNo"
          type="text"
          name="phoneNo"
          dataName="phoneNoSG"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.phoneNo')}
          value={phoneNo}
          placeholder={transUTL('translatePlaceholder.inputSG.phoneNo')}
          placeholderTrigger={isEmptyVAL(phoneNo) ? 'input-empty' : ''}
          error={errors.phoneNo}
          errorTrigger={errors.phoneNo ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
    {
      belongsTo: [],
      element: (
        <TextFieldGroup
          key="emailAddress"
          id="emailAddress"
          type="text"
          name="emailAddress"
          dataName="emailAddressSG"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.emailAddress')}
          value={emailAddress}
          placeholder={transUTL('translatePlaceholder.inputSG.emailAddress')}
          placeholderTrigger={isEmptyVAL(emailAddress) ? 'input-empty' : ''}
          error={errors.emailAddress}
          errorTrigger={errors.emailAddress ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

ContactDetailsSingapore.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default ContactDetailsSingapore;
